export const RDG_MIN_HEIGHT = 490;
export const RDG_CHECK_BOX_COLUMN_WIDTH = 60;
export const RDG_HEADER_ROW_HEIGHT = 110;
